import { createFileRoute } from '@tanstack/react-router';
import { useMe } from '../../../api/me.ts';
import { AdminOverview } from '../../../shell/admin-nav.tsx';

export const Route = createFileRoute('/_authed/admin/')({
  component: AdminIndex,
});

function AdminIndex(): React.JSX.Element {
  const me = useMe();
  return (
    <section className="page">
      <h1 className="page__title">Owner admin</h1>
      <AdminOverview me={me} />
    </section>
  );
}
